let fault: Error | undefined;

export function getDataWorkerFault(): Error | undefined {
    return fault;
}

export function getIsDataWorkerFaulted(): boolean {
    return !!fault;
}

export function setIsDataWorkerFaulted(e: Error | undefined): void {
    fault = e;
}
